module.exports = __webpack_public_path__ + "static/mert-haciosmanoglu-b4833024d2ac8677fbf2016c39d940e3.png";